import styles from "./styles.module.scss";
import React, { FunctionComponent, useEffect, useState } from "react";
import { Draggable } from "@hello-pangea/dnd";
import { useTheme } from "@mui/material";
import { LazyImageAspectFit } from "../../LazyImageAspectFit";
import { IAlbum } from "../../../hooks/albums";
import { IShelving } from "../../../hooks/shelvings";
import { Icon, IconType } from "../../../icons";
import { ImageUtilities } from "../../../models/ImageUtilities";

export const AlbumSpineDraggable: FunctionComponent<IAlbumSpineDraggableProps> = ({
  isDragDisabled,
  album,
  shelving,
  section,
  index
}) => {
  const theme = useTheme();
  const genericSpine = new URL("../../../images/generic_spine.png", import.meta.url).href;
  useEffect(() => {
    const thumbnail = album.thumbnail;
    if (!thumbnail) setTintColor(undefined);
    const image = new Image();
    image.src = `data:image/png;base64,${thumbnail}`;
    image.onload = function () {
      setTintColor(ImageUtilities.getDominantColor(image));
    };
  }, [album.thumbnail]);
  const [tintColor, setTintColor] = useState<string | undefined>();
  return (
    <div className={styles.spineImageContainer}>
      <Draggable
        isDragDisabled={isDragDisabled}
        key={`${album.uuid}_${index}`}
        draggableId={`${section}_${index}`}
        index={index}
      >
        {provided => (
          <div
            className={
              shelving?.orientation == "vertical"
                ? styles.spineDraggableDivVertical
                : styles.spineDraggableDivHorizontal
            }
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            <div
              className={
                shelving?.orientation == "vertical"
                  ? styles.spineDragHandleVertical
                  : styles.spineDragHandleHorizontal
              }
              style={{
                borderColor: theme.palette.background.default,
                visibility: isDragDisabled ? "hidden" : "visible"
              }}
            >
              <Icon
                type={IconType.DragIndicator}
                style={{
                  fontSize: "14px",
                  backgroundColor: theme.palette.background.default,
                  color: theme.palette.primary.main
                }}
              />
            </div>
            <LazyImageAspectFit
              className={
                shelving?.orientation == "vertical"
                  ? styles.spineImageVertical
                  : styles.spineImageHorizontal
              }
              defaultImage={genericSpine}
              alt={album.name}
              forceVertical={shelving ? shelving.orientation == "horizontal" : true}
              forceHorizontal={shelving ? shelving.orientation == "vertical" : false}
              tintColor={tintColor}
              waitUntilImageIsFinal
            />
          </div>
        )}
      </Draggable>
    </div>
  );
};

export interface IAlbumSpineDraggableProps {
  isDragDisabled: boolean;
  album: IAlbum;
  shelving: IShelving;
  section: number;
  index: number;
}
